module.exports = __webpack_public_path__ + "static/img/hqpcb_gzh.f2dc11d1.jpg";